import { z } from 'zod';
import type { CourseDto } from '../types/CourseDto';

export const courseDtoSchema = z.object({
  id: z.string().uuid(),
  title: z.string().min(3).max(255),
  description: z.string().min(3).max(255).nullable(),
  cover: z.string().nullable(),
  isPublic: z.boolean().default(true).optional(),
  isActive: z.boolean().default(false).optional(),
  numberOfViews: z.number().int().min(0).default(0).optional(),
  numberOfReviews: z.number().int().min(0).default(0).optional(),
  creatorId: z.string().uuid(),
  createdAt: z.string().datetime({ offset: true }),
  updatedAt: z.string().datetime({ offset: true }),
  deletedAt: z.string().datetime({ offset: true }).nullable(),
}) as z.ZodType<CourseDto>;
